export class KnowledgeBaseConsultActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
